import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';

import logo from "../../images/logo.svg";

const Header = (props) => {
    const [resources, setResources] = useState({});
    const { language } = useParams();

    useEffect(() => {
        requestResources();
    }, [language]);

    const requestResources = async () => {
        try {
            const res = await axios.get(`form/resources/${language}`);
            setResources(res.data?.translation);
        } catch (error) {
            console.error(error?.response?.data);
        }
    };

    return (
        <>
            <header>
                <div className="container">
                    <div className="row">
                        <div className="col-md-12 d-flex align-items-center">
                            <img src={logo} className="logo me-3" alt="Weinfestival Basel 2026" />
                            WEINFESTIVAL BASEL 2026
                        </div>
                    </div>
                </div>
            </header>
        </>
    );
};

export default Header;
